// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#loader-dot-1{-webkit-animation-delay:.2s;animation-delay:.2s}#loader-dot-2{-webkit-animation-delay:.4s;animation-delay:.4s}#loader-dot-3{-webkit-animation-delay:.6s;animation-delay:.6s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
